import { render, staticRenderFns } from "./ReviewList.vue?vue&type=template&id=1cdc2505&scoped=true&lang=html&"
import script from "./ReviewList.vue?vue&type=script&lang=js&"
export * from "./ReviewList.vue?vue&type=script&lang=js&"
import style0 from "./ReviewList.vue?vue&type=style&index=0&id=1cdc2505&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdc2505",
  null
  
)

component.options.__file = "ReviewList.vue"
export default component.exports